import * as React from 'react';
import { AlertIcon } from '../AlertIcon/AlertIcon';


export var Alert = function (_a) {
    var message = _a.message, _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, className = _a.className;
    var classes = "pluggy alert " + type + " " + size + " " + (className || '');
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: 'indicator' }),
        React.createElement(AlertIcon, { name: type, className: 'icon' }),
        React.createElement("div", { className: 'text' }, message)));
};
